module.exports = __webpack_public_path__ + "img/pdb-mid-section.33efaee1.png";